import React from 'react';

import { ContentPushWrapper } from './AIInsightsSidebar.styles';
import { useAIInsightsSidebar } from './AIInsightsSidebarContext';

interface AIInsightsSidebarContentPushProps {
  children: React.ReactNode;
}

/**
 * Wraps page content and applies padding-right equal to the sidebar width
 * on desktop when the sidebar is open, so content is pushed rather than overlapped.
 * On tablet and below the sidebar overlays, so no padding is applied.
 */
export const AIInsightsSidebarContentPush = ({ children }: AIInsightsSidebarContentPushProps) => {
  const ctx = useAIInsightsSidebar();

  if (!ctx) return <>{children}</>;

  return (
    <ContentPushWrapper $isOpen={ctx.isOpen} $sidebarWidth={ctx.sidebarWidth} $isResizing={ctx.isResizing}>
      {children}
    </ContentPushWrapper>
  );
};
